<div class="flex h-full w-full items-center gap-2">
  <div class="min-w-0 flex-grow">
    @if (editing()) {
      <aux-input
        class="mr-2 w-full"
        [ngModel]="titleSignal()"
        (ngModelChange)="titleSignal.set($event.toUpperCase())"
        (keydown.enter)="finishEditing(titleSignal())"
        (blur)="finishEditing(titleSignal())"
        (auxClickOutside)="finishEditing(titleSignal())"
        (blured)="finishEditing(titleSignal())"
        [autofocus]="true"
      />
    } @else {
      <div
        #titleDiv
        class="line-clamp-2 w-full break-words pl-2"
        (click)="startEditing()"
        [auxTooltipOverflow]="titleSignal()"
        [class.cursor-pointer]="params.isHeaderEditable"
      >
        {{ titleSignal() || '&nbsp;' }}
      </div>
    }
  </div>
  <aux-button
    [auxTooltip]="params.removeColumnTooltip || ''"
    [disabled]="!!params.removeColumnDisabled"
    (click)="handleDelete($event)"
    variant="tertiary"
    classList="px-2 ml-2 my-auto"
    class="flex h-full flex-shrink-0 items-center border-l"
    [icon]="'Trash'"
    [svgAttributes]="'text-aux-error'"
  />
</div>
